import { Box } from '@chakra-ui/react';
import React from 'react';
import Lottie from 'react-lottie-player';
import waitingLottie from '../lottie/waiting.json';

const ModalWaitingIcon = () => {
	return (
		<Box w="151px" mx="auto">
			<Lottie loop animationData={waitingLottie} play style={{ width: '100%' }} />
		</Box>
	);
};

export default ModalWaitingIcon;
